/**
 * Formats a numeric value as a currency string with a specified sign.
 * * This function ensures the amount is treated as a number, handles null/undefined/non-numeric
 * values by defaulting to 0, and correctly places the negative sign outside the currency
 * symbol if the amount is negative. It formats the value to two decimal places.
 *
 * @param {string | number | null | undefined} val - The raw amount value. It can be a string, number, null, or undefined.
 * @param {string} selectedCurrencySign - The currency symbol (e.g., '$', '€', '₹').
 * @returns {string} The formatted currency string (e.g., "$1,234.56", "-€50.00").
 */
export const getAmount = (val, selectedCurrencySign) => {
    const amount = parseFloat(val || 0);
    return `${amount < 0 ? '-' : ''}${selectedCurrencySign}${Math.abs(amount).toFixed(2)}`;
};